import { ChangeEvent } from 'react';
import { Select } from '@fabric-ds/react';

interface Props {
    numberOfBeds: string | null;
    onChange: (event: ChangeEvent<HTMLSelectElement>) => void;
    numberOfGuests: number;
}

export const CalendarSelectGuests = ({ numberOfBeds, onChange, numberOfGuests }: Props) => {
    const maxNoOfGuests = numberOfBeds ? Number(numberOfBeds) : 10;
    const guestOptions = Array.from({ length: maxNoOfGuests }, (_, i) => {
        const option = i + 1;
        return (
            <option key={option} value={option}>
                {option}
            </option>
        );
    });

    return (
        <Select label={'Antall gjester'} onChange={onChange} value={numberOfGuests.toString()}>
            {guestOptions}
        </Select>
    );
};
